export default __webpack_public_path__ + "static/media/card-3.aabe2981.webp";